import gql from 'graphql-tag';

const query = gql`
  query Settings {
    me {
      id
      systemOfMeasures
      systemOfMeasuresNutrition
    }
  }
`;

export default query;
